<template>
  <div id="retours">
    <Title :titlePage="titlePage" />
    <v-container fluid class="pa-4 pb-0">

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          placeholder="Rechercher un retour par client / date / numéro"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          clearable
          class="filter-search"
          @input="onSearchInput"
          @click:clear="onSearchClear"
        />
      </div>

      <Popup :dialog="dialogDelete" text="Supprimer ce retour ?" actions="" heightProp="" widthProp="" showClose="false">
        <v-card-actions class="mb-10">
          <v-btn color="#0B87BA" width="100px" large dark rounded @click="deleteItemConfirm">Oui</v-btn>
          <v-btn color="#0B87BA" width="100px" large dark rounded @click="dialogDelete = false">Non</v-btn>
        </v-card-actions>
      </Popup>

      <resultList
        @emitDialogRetour="openDeleteDialog"
        :header="headerRetours"
        :items="retours"
        :nbResult="displayItem"
        :type="'retours'"
        @sort="sort"
        :totalItems="totalItems"
        :page="page"
        :canModif="canModif"
        height="calc(87vh - 175px)"
      />

      <div v-if="nbPage > 1" class="pagination-bar">
        <button class="page-btn" :disabled="page === 1" @click="page--">
          <v-icon small>mdi-chevron-left</v-icon>
        </button>
        <span class="page-info">Page {{ page }} / {{ nbPage }}</span>
        <button class="page-btn" :disabled="page === nbPage" @click="page++">
          <v-icon small>mdi-chevron-right</v-icon>
        </button>
      </div>

    </v-container>
  </div>
</template>

<script>
import Popup from "@/components/shared/Popup";
import Title from "@/components/shared/Title";
import ResultList from "@/components/shared/ResultList";
import api from "@/api/user";
import apiRetour from "@/api/retours";

export default {
  name: "RetoursEnCours",
  components: { Title, ResultList, Popup },
  data() {
    return {
      titlePage: "Retours en cours",
      search: "",
      column: "creation_date",
      order: "DESC",
      page: 1,
      totalItems: 0,
      displayItem: process.env.VUE_APP_NB_DISPLAY,
      retours: [],
      nbPage: 0,
      canModif: 0,
      id_retour: 0,
      dialogDelete: false,
      searchTimeout: null,
      headerRetours: [
        { text: "CLIENT",                   align: "center", sortable: false, value: "Entreprise.raison_sociale" },
        { text: "DATE DE CREATION",         align: "center", sortable: true,  value: "creation_date", name: "creation_date" },
        { text: "N° RETOUR",               align: "center", sortable: false, value: "numero_retour" },
        { text: "MAIL DU CLIENT",           align: "center", sortable: false, value: "email_client" },
        { text: "VALIDATION",              align: "center", sortable: false, value: "validation_commercial" },
        { text: "DATE D'ENVOI AU PLUS TARD", align: "center", sortable: false, value: "date_envoi_limite" },
        { text: "CODES PRODUITS",          align: "center", sortable: false, value: "references" },
        { text: "TYPE",                    align: "center", sortable: false, value: "TypeRetour.type_retour" },
        { text: "ACTIONS",                 align: "center", sortable: false, value: "actionsRetour" },
      ],
    };
  },
  watch: {
    page() {
      this.getRetours();
    },
  },
  methods: {
    extractReferences(retourAArticles) {
      return retourAArticles.flatMap(r => r.ArticleRetour.map(a => a.reference));
    },
    getRetours() {
      const id = this.$store.state.AsUser.id_utilisateur || "";
      api.getUserRetours(id, this.search, this.column, this.order, this.page - 1).then((res) => {
        this.totalItems = res.data.retours.totalItems;
        this.nbPage = res.data.retours.totalPages;
        const currentUser = this.$store.state.AsUser.id_utilisateur === ""
          ? this.$store.state.user.id_utilisateur
          : this.$store.state.AsUser.id_utilisateur;
        this.retours = res.data.retours.rows.map(retour => {
          const usersEntreprise = retour.Entreprise.Users.map(u => u.id_utilisateur);
          return {
            ...retour,
            client: retour.Entreprise.raison_sociale,
            references: this.extractReferences(retour.RetourAArticles),
            // #1124 : retours en écriture (administrateurs et profil Retours)
            canModif: this.$peut('retours', 'ecriture', usersEntreprise.includes(currentUser)) ? 1 : 0,
          };
        });
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
    sort(sortEvent) {
      if (sortEvent.column !== undefined) {
        this.column = sortEvent.column;
        this.page = sortEvent.page;
      }
      if (sortEvent.order !== undefined) {
        this.order = sortEvent.order ? "ASC" : "DESC";
      }
      this.getRetours();
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.getRetours();
      }, 350);
    },
    onSearchClear() {
      this.search = "";
      this.page = 1;
      this.getRetours();
    },
    openDeleteDialog(id) {
      this.id_retour = id;
      this.dialogDelete = true;
    },
    canModified() {
      if (this.$portee('retours', 'ecriture') !== 'none') {
        this.canModif = 1;
      }
    },
    deleteItemConfirm() {
      apiRetour.deleteRetour(this.id_retour).then(() => {
        this.dialogDelete = false;
        this.getRetours();
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de la suppression' });
      });
    },
  },
  created() {
    this.getRetours();
    this.canModified();
  },
};
</script>

<style scoped lang="scss">
#retours {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.filter-search {
  max-width: 400px;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 0 2px;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover:not(:disabled) {
    background: #f0f0f0;
    border-color: #0b87ba;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}

.page-info {
  font-size: 0.82rem;
  color: #555;
  font-weight: 500;
  min-width: 90px;
  text-align: center;
}
</style>
